import { useQuery } from 'react-query';
import {
  ADDRESS_AUTOCOMPLETE_QUERY_KEY,
  queryAddressAutocomplete,
} from './useAddressAutocomplete.query';
import { UseAddressAutocompleteQueryParams } from './useAddressAutocomplete.types';

export const useAddressAutocomplete = (
  address: string,
  params?: UseAddressAutocompleteQueryParams
) => {

  const enabled = params?.enabled === undefined ? true : false

  return (
    useQuery(
      [ADDRESS_AUTOCOMPLETE_QUERY_KEY, address],
      () => queryAddressAutocomplete(address, params),
      {
        retry: false,
        refetchOnWindowFocus: false,
        enabled: Boolean(enabled)
      }
    )
  )
}
